export default __webpack_public_path__ + "static/media/Illustration.421a56cd.png";